import React from 'react'
import { useSelector } from 'react-redux'

import PokemonCard from '../components/PokemonCard.js'

export default function Favorites() {

      const favoritePokemons = useSelector(state => state.favoritePokemons.favoritePokemons)

      console.log()
      return (
            <div className="py-2">
                  <h1 className="text-2xl">Favorites will be reset if you refresh the page</h1>
                  <p className="text-xl text-gray-600">favorites are stored in redux</p>
                  <section data-testid="favorites" className="flex flex-wrap">
                        {
                              favoritePokemons && favoritePokemons.map(pokemon => (
                                    < PokemonCard key={pokemon.name} pokemon={pokemon} />
                              ))
                        }
                  </section>
            </div>
      )
}
